import { Refresh } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import React from "react";

export default function CustomToolbar({ onRefresh }) {
  return (
    <GridToolbarContainer sx={{ my: 2 }}>
      <GridToolbarQuickFilter />
      <Box sx={{ flexGrow: 1 }} />
      <GridToolbarFilterButton />
      <Button onClick={onRefresh} startIcon={<Refresh />}>
        <Typography variant="subtitle2" color="primary">
          REFRESH
        </Typography>
      </Button>
    </GridToolbarContainer>
  );
}
